import type { Translation } from '../types.ts';
import type en from '../en/vehicles.ts';

export default {
    status: {
        draft: 'Concept',
        available: 'Beschikbaar',
        reserved: 'Gereserveerd',
        sold: 'Verkocht',
    },
    condition: {
        used: 'Gebruikt',
        new: 'Nieuw',
        demo: 'Demo',
    },
    vat: {
        margin: 'Margeregeling (geen aftrekbare btw)',
        vat: 'Btw verrekenbaar',
    },
    body: {
        hatchback: 'Hatchback',
        sedan: 'Sedan',
        estate: 'Stationwagen',
        suv: 'SUV',
        mpv: 'MPV',
        coupe: 'Coupé',
        convertible: 'Cabriolet',
        pickup: 'Pick-up',
        van: 'Bedrijfswagen',
        other: 'Overig',
    },
    fuel: {
        petrol: 'Benzine',
        diesel: 'Diesel',
        electric: 'Elektrisch',
        lpg: 'LPG',
        cng: 'CNG',
        hydrogen: 'Waterstof',
        ethanol: 'Ethanol',
        other: 'Overig',
    },
    transmission: {
        manual: 'Handgeschakeld',
        automatic: 'Automaat',
        semi_automatic: 'Semi-automaat',
    },
    colour: {
        black: 'Zwart',
        white: 'Wit',
        grey: 'Grijs',
        silver: 'Zilver',
        blue: 'Blauw',
        red: 'Rood',
        green: 'Groen',
        yellow: 'Geel',
        orange: 'Oranje',
        brown: 'Bruin',
        beige: 'Beige',
        gold: 'Goud',
        purple: 'Paars',
        other: 'Overig',
    },
    listingState: {
        pending: 'In behandeling',
        published: 'Gepubliceerd',
        failed: 'Mislukt',
        withdrawn: 'Ingetrokken',
    },
    shared: {
        newCar: 'Nieuwe auto',
        onRequest: 'Op aanvraag',
        notSet: 'Niet ingevuld',
        platforms: 'Platforms',
    },
    list: {
        title: 'Voertuigvoorraad',
        searchPlaceholder: 'Zoek op merk, model, kenteken of voorraadnummer…',
        anyStatus: 'Alle statussen',
        noMatch: "Geen auto's gevonden voor deze zoekopdracht.",
        empty: "Nog geen auto's. Voeg de eerste toe met {newCar}.",
        photo: 'Foto',
        car: 'Auto',
        kenteken: 'Kenteken',
        year: 'Bouwjaar',
        km: 'Km',
        websiteOnly: 'Alleen website',
        count: "geen auto's | {n} auto | {n} auto's",
    },
    edit: {
        tabs: {
            general: 'Algemeen',
            specs: 'Specificaties',
            price: 'Prijs',
            description: 'Omschrijving en uitrusting',
            photos: "Foto's",
            platforms: 'Platforms',
        },
        noCarFound: 'Geen auto gevonden met dat kenteken.',
        prefilled: 'De RDW heeft niets aan te vullen. | {n} veld ingevuld vanuit de RDW. | {n} velden ingevuld vanuit de RDW.',
        sentToPlatforms: 'Naar de platforms gestuurd. Vernieuw zo meteen om het resultaat te zien.',
        added: 'Auto toegevoegd',
        savedWithPlatforms: 'Opgeslagen. De platforms worden op de achtergrond bijgewerkt.',
        confirmDelete: '"{title}" verwijderen? Dit kan niet ongedaan worden gemaakt.',
        confirmDeleteListed: '"{title}" verwijderen? De auto wordt eerst van {platforms} gehaald. Dit kan niet ongedaan worden gemaakt.',
        deleted: 'Auto verwijderd',
        deleteRefused: '{message} Zie het tabblad Platforms.',
        car: 'Auto',
        kenteken: 'Kenteken',
        fillFromRdw: 'Invullen via RDW',
        fillFromRdwHelp: 'Vult de lege velden aan uit het Nederlandse kentekenregister; wat je zelf hebt ingevuld blijft staan.',
        fillFromRdwHelpNew: 'Een volledig Nederlands kenteken wordt meteen opgezocht en vult de lege velden aan uit het kentekenregister; wat je zelf hebt ingevuld blijft staan.',
        lookupOff: 'Wil je de auto invullen vanaf het kenteken? Zet Kenteken opzoeken aan onder Websites → Modules.',
        make: 'Merk',
        model: 'Model',
        variant: 'Uitvoering',
        vin: 'Chassisnummer (VIN)',
        dealerRef: 'Voorraadnummer',
        dealerRefHint: 'Je eigen referentie, als je die bijhoudt.',
        slug: 'URL-slug',
        statusHint: "Beschikbare en gereserveerde auto's staan op de platforms; verkochte auto's worden eraf gehaald.",
        condition: 'Staat',
        soldOn: 'Verkocht op {date}.',
        specifications: 'Specificaties',
        body: 'Carrosserie',
        fuel: 'Brandstof',
        secondaryFuel: 'Tweede brandstof (hybride)',
        transmission: 'Transmissie',
        mileage: 'Kilometerstand (km)',
        owners: 'Vorige eigenaren',
        firstRegistration: 'Eerste toelating',
        buildYear: 'Bouwjaar',
        apkUntil: 'APK tot',
        power: 'Vermogen (kW)',
        powerHp: '{hp} pk',
        engine: 'Cilinderinhoud (cc)',
        co2: 'CO₂ (g/km)',
        doors: 'Deuren',
        seats: 'Zitplaatsen',
        colour: 'Kleur',
        colourHint: 'Waar de platforms op filteren.',
        colourName: 'Kleurnaam van de fabrikant',
        askingPrice: 'Vraagprijs',
        askingPriceHint: 'Incl. btw als die er is. Laat leeg voor prijs op aanvraag.',
        vat: 'Btw',
        vatHint: 'De prijs van een btw-auto is inclusief btw die een zakelijke koper kan verrekenen; de platforms tonen die apart.',
        descriptionHint: 'Platte tekst: de platforms accepteren geen opmaak.',
        descriptionFallback: 'Leeg valt terug op de standaardtaal.',
        equipment: 'Uitrusting',
        equipmentFilter: 'Filteren, bijv. camera',
        equipmentNoMatch: 'Niets in de lijst komt overeen. Voeg het hieronder toe bij Overige uitrusting.',
        otherEquipment: 'Overige uitrusting',
        otherEquipmentPlaceholder: 'M Sport-pakket\nWinterpakket',
        otherEquipmentHint: 'Wat in de lijst hierboven ontbreekt, één item per regel. Platforms tonen deze als tekst.',
        photos: "Foto's",
        photosHelp: 'De eerste foto is de hoofdfoto. Klik op een foto om hem te vervangen; gebruik de pijlen om de volgorde te wijzigen.',
        replacePhoto: 'Foto vervangen',
        altText: 'Alt-tekst',
        altPlaceholder: 'Driekwart vooraanzicht',
        cover: 'Hoofdfoto',
        addPhoto: '+ Foto toevoegen',
        noPlatforms: 'Er zijn nog geen platforms gekoppeld. De auto staat alleen op je eigen website; AutoScout24 (met AutoTrack) en Marktplaats verschijnen hier zodra ze beschikbaar zijn.',
        platformsHelp: 'Kies waar deze auto wordt geadverteerd. Wijzigingen gaan na het opslaan op de achtergrond de deur uit.',
        viewListing: 'Advertentie bekijken',
        platformInactive: 'Niet actief voor deze website: zet het aan en vul de inloggegevens in onder Websites → Module-instellingen → Voertuigvoorraad.',
        lastSent: 'Laatst verstuurd {date}',
        sendAgain: 'Nu opnieuw versturen',
        pickPhoto: 'Kies of upload een foto',
    },
    credentials: {
        title: '{name}: inloggegevens',
        savedPlaceholder: '•••••••• (opgeslagen, laat leeg om te behouden)',
        stored: 'opgeslagen',
        needsCredentials: 'inloggegevens nodig',
        confirmRemove: 'Opgeslagen {label} verwijderen?',
        removed: '{label} verwijderd.',
        removeFailed: 'Verwijderen van het gegeven is mislukt.',
        test: 'Verbinding testen',
        saveFirst: 'Sla eerst de inloggegevens op.',
    },
    stockSettings: {
        loadFailed: 'Laden van de instellingen voor de voertuigvoorraad is mislukt.',
        saved: 'Instellingen voor de voertuigvoorraad opgeslagen.',
        saveFailed: 'Opslaan van de instellingen voor de voertuigvoorraad is mislukt.',
        testOk: 'De inloggegevens werken.',
        testFailed: 'De test is mislukt.',
        intro: "Waar de voertuigvoorraad van deze website wordt gepubliceerd. Per auto kies je daarna naar welke van deze platforms hij gaat. Zet je een platform uit, dan gaan alle auto's eraf.",
        noPlatforms: 'Er zijn nog geen platforms beschikbaar. AutoScout24 (met AutoTrack) en Marktplaats verschijnen hier zodra ze gekoppeld zijn.',
    },
    lookup: {
        loadFailed: 'Laden van de instellingen voor kenteken opzoeken is mislukt.',
        saved: 'Instellingen voor kenteken opzoeken opgeslagen.',
        saveFailed: 'Opslaan van de instellingen voor kenteken opzoeken is mislukt.',
        confirmRemove: 'Opgeslagen {label} voor {country} verwijderen?',
        lookupFailed: 'Het opzoeken is mislukt.',
        countries: 'Landen',
        countriesIntro: 'Welke registers deze website mag raadplegen. Een land werkt alleen als er een provider voor is: NL gebruikt het open register van de RDW; andere landen hebben een betaalde provider nodig voordat ze hier verschijnen.',
        noProviders: 'Er zijn geen registerproviders geïnstalleerd.',
        behaviour: 'Gedrag',
        cacheHours: 'Resultaten bewaren (uren)',
        cacheHint: 'Registraties veranderen nauwelijks, dus een dag is ruim genoeg en houdt je binnen de limiet van het register. 0 schakelt bewaren uit.',
        exposeRaw: 'Volledige registergegevens vrijgeven',
        exposeRawHelp: 'Standaard uit. Het publieke endpoint geeft merk, model en bouwjaar; als je dit aanzet, krijgt iedereen die het endpoint aanroept ook alle andere gegevens uit het register (gewichten, keuringsdata, taxatie).',
        testTitle: 'Kenteken testen',
        testIntro: 'Doet een echte opzoeking met de opgeslagen inloggegevens, via dezelfde weg als de website. Sla eerst op als je net een sleutel hebt gewijzigd.',
        plate: 'Kenteken',
        lookUp: 'Opzoeken',
        enableCountryFirst: 'Zet hierboven minstens één land aan (en sla op) voordat je test.',
        notFound: 'Geen voertuig gevonden met dat kenteken.',
        vehicle: 'Voertuig',
        fuel: 'Brandstof',
        body: 'Carrosserie',
        firstRegistration: 'Eerste toelating',
    },
} satisfies Translation<typeof en>;
